import { mapValues } from '../utils/mapValues';
import { contentComponentMapper } from './content.mapper';
const toDomain = backofficePage => ({
  id: backofficePage.id,
  templateName: backofficePage.templateName,
  biSlug: backofficePage.biSlug,
  content: mapValues(backofficePage.content, contentComponentMapper.toDomain)
});
export const pageMapper = {
  toAPI: () => {
    throw new Error('not implemented: pageMapper#toAPI');
  },
  toDomain
};
//# sourceMappingURL=page.mapper.js.map